
(function () {
  const now = Date.now();

  // 1) Prune any scheduled elements before sliders initialise
  const elements = document.querySelectorAll('[data-schedule-start], [data-schedule-end]');

  elements.forEach(element => {
    const startString = element.getAttribute('data-schedule-start');
    const endString = element.getAttribute('data-schedule-end');

    let isActive = true;

    if (startString) {
      const from = Date.parse(startString);
      if (!isNaN(from) && now < from) {
        isActive = false;
      }
    }

    if (endString) {
      const to = Date.parse(endString);
      if (!isNaN(to) && now >= to) {
        isActive = false;
      }
    }

    if (!isActive) {
      // Completely remove out-of-schedule elements
      element.remove();
    } else {
      // In schedule → make sure "hidden" is removed if present
      element.classList.remove('hidden');
      // IMPORTANT: do NOT touch aria-hidden here
    }
  });

  // 2) Clean up announcement bars AFTER pruning
  document.querySelectorAll('announcement-bar-component').forEach(component => {
    const slides = Array.from(component.querySelectorAll('.announcement-bar__slide'));

    // No slides left? Remove the entire bar.
    if (!slides.length) {
      const wrapper = component.closest('.announcement-bar');
      if (wrapper) {
        wrapper.remove();
      } else {
        component.remove();
      }
      return;
    }

    // Ensure there is at least one visible slide (aria-hidden="false")
    let visibleSlide = slides.find(
      slide => slide.getAttribute('aria-hidden') === 'false'
    );

    if (!visibleSlide) {
      // If the original "first" slide was removed, promote the new first slide
      slides[0].setAttribute('aria-hidden', 'false');
    }
  });
})();


document.querySelectorAll('a[href]').forEach(link => {
    if (link.href.startsWith('mailto:') || link.href.startsWith('tel:') || link.hash) {
        return;
    }

    const url = new URL(link.href, window.location.origin);

    if (url.hostname !== window.location.hostname) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
    }
});
